import { collection, doc, setDoc } from "firebase/firestore";
import { db } from "../config/firebaseConfig";

export const getAppointmentChatCollection = (appointmentNumber) =>  {
    return  collection(
                doc(db, 'appointmentChat', appointmentNumber),
                'chat'
    );
}

export const setMessageToAppointmentChatCollection = async (appointmentNumber, messageId, messageData) => {
   
      const messageRef = doc(
        db,
        "appointmentChat",
        appointmentNumber,
        "chat",
        messageId
      );
  
    const data = await setDoc(messageRef, messageData);
     return data;
    
  };
